import { foot, px, type WorldObject } from './mapdef';

/** Interactive objects for the trips: the town station, the MRT, the museum and the Hualien hotel (districts live in objects<Pkg>.ts). */
export const OBJECTS4: readonly WorldObject[] = [
  // Town station
  { id: 'stTicket', map: 'station', rect: foot(2, 2, 4, 12), solid: true, label: 'stTicket', icon: '🎫', tall: 34 },
  { id: 'stTrain', map: 'station', rect: { x: px(2), y: px(9) + 6, w: px(16), h: 10 }, solid: false, label: 'stTrain', icon: '🚆', tall: 30 },
  // MRT
  { id: 'mrtMap', map: 'mrt', rect: foot(3, 1, 4, 10), solid: true, label: 'mrtMap', icon: '🗺️', tall: 34 },
  { id: 'mrtRules', map: 'mrt', rect: foot(18, 1, 3, 10), solid: true, label: 'mrtRules', icon: '📋', tall: 34 },
  { id: 'mrtRide', map: 'mrt', rect: { x: px(8), y: px(9) + 6, w: px(10), h: 10 }, solid: false, label: 'mrtRide', icon: '🚇', tall: 30 },
  // Palace Museum
  { id: 'muCabbage', map: 'museum', rect: foot(4, 4, 3, 12), solid: true, label: 'muCabbage', icon: '🥬', tall: 40 },
  { id: 'muMeat', map: 'museum', rect: foot(10, 4, 3, 12), solid: true, label: 'muMeat', icon: '🥓', tall: 40 },
  { id: 'muDing', map: 'museum', rect: foot(17, 4, 3, 12), solid: true, label: 'muDing', icon: '🏺', tall: 40 },
  { id: 'muRuware', map: 'museum', rect: foot(23, 4, 3, 12), solid: true, label: 'muRuware', icon: '🫖', tall: 40 },
  { id: 'muScroll', map: 'museum', rect: foot(5, 11, 8, 8), solid: true, label: 'muScroll', icon: '📜', tall: 30 },
  { id: 'muCurio', map: 'museum', rect: foot(18, 11, 4, 10), solid: true, label: 'muCurio', icon: '🎁', tall: 34 },
  { id: 'muExit', map: 'museum', rect: { x: px(12) + 4, y: px(14) + 4, w: px(4) - 8, h: 10 }, solid: false, label: 'muExit', icon: '🚇', tall: 20 },
  // Seaside hotel
  { id: 'htDesk', map: 'hotel', rect: foot(2, 2, 4, 12), solid: true, label: 'htDesk', icon: '🛎️', tall: 34 },
  { id: 'htBed', map: 'hotel', rect: foot(10, 3, 3, 14), solid: true, label: 'htBed', icon: '🛏️', tall: 30 },
];
